export const BUTTON_ELEVATIONS = ["raised", "normal", "sunken"];
export const BUTTON_SIZES = ["sm", "md", "lg"];
export const BUTTON_VARIANTS = ["primary", "secondary", "tertiary"];
